import { Types } from 'mongoose';

import { IBaseEntity } from '../common';

export enum REASSIGNMENT_JOB_STATUS {
  QUEUED = 'QUEUED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface IReassignmentJobBreakdownItem {
  total: number;
  processed: number;
}

export interface IReassignmentJobBreakdown {
  leads: IReassignmentJobBreakdownItem;
  activities: IReassignmentJobBreakdownItem;
  policies: IReassignmentJobBreakdownItem;
  recruitments: IReassignmentJobBreakdownItem;
}

export interface IReassignmentJob extends IBaseEntity {
  source_agent_id: Types.ObjectId | string;
  source_agent_code: string;
  target_agent_id: Types.ObjectId | string;
  target_agent_code: string;
  remarks?: string;
  status: REASSIGNMENT_JOB_STATUS;
  total_records: number;
  processed_records: number;
  breakdown: IReassignmentJobBreakdown;
  error_log?: string[];
  started_at?: Date;
  completed_at?: Date;
}
